import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const scrollReveal = {
  reveal: (elements) => {
    const targets = Array.from(elements || []).filter((el) => el && !el.dataset.srInit);
    if (targets.length === 0) return;

    targets.forEach((element) => {
      element.dataset.srInit = 'true';
    });

    gsap.set(targets, {
      opacity: 0,
       y: -20,
    });

    targets.forEach((element) => {
      gsap.to(element, {
        opacity: 1,
        duration: 1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: element,
          start: 'top bottom-=150',
          once: true 
        }
      });
      ScrollTrigger.batch(targets, {
        onEnter: batch => gsap.to(batch, {
          opacity: 1,
          duration: .5,
          ease: 'power2.out',
          y: 0,
          stagger: {
            each: 0.2,
            grid: 'auto'
          },
          overwrite: true
        }),
      });
    });
  },
  init: () => {
    const sr = document.querySelectorAll('main .sr');
    scrollReveal.reveal(sr);
  }
};

export default scrollReveal;
